import React from 'react'
import { InstallationLocationChangeForm } from '../models'
import { useFormikContext } from 'formik'
import { Box, Stack, Typography } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Checkbox, TextField, Select } from 'src/Libs/inputs/formik'
import { useCountryOptions } from '@e3dc-react/shell/Hooks/useCountryOptions'
import { Trans } from 'react-i18next'
import { InformationBox } from 'src/Components'

/**
 * Form to change address of an installation
 */
const ChangeLocationForm: React.FC = () => {
  const { t } = useCustomTranslation()
  const { allCountries } = useCountryOptions()
  const { handleSubmit } = useFormikContext<InstallationLocationChangeForm>()

  return (
    <form onSubmit={handleSubmit}>
      <InformationBox
        text={
          (
            <Typography variant={'subtitle2'}>
              <Trans i18nKey={'installation-details.change-location.description'} components={{ break: <Box component="br" /> }} />
            </Typography>
          ) as unknown as string
        }
        messageType="warning"
      />
      <Typography variant="h3" sx={{ marginTop: 4, marginBottom: 4 }}>
        {t('installation-details.change-location.subtitle')}
      </Typography>
      <Stack gap={3}>
        <Stack gap={3} direction={{ xs: 'column', sm: 'row' }}>
          <Box sx={{ width: { xs: '100%', sm: '70%' } }}>
            <TextField label={t('common.street')} name="streetName" required delayInMs={0} />
          </Box>
          <Box sx={{ width: { xs: '100%', sm: '30%' } }}>
            <TextField label={t('common.streetNumber')} name="streetNumber" required delayInMs={0} />
          </Box>
        </Stack>
        <TextField label={t('common.zip')} name="zip" required delayInMs={0} />
        <TextField label={t('common.city')} name="city" required delayInMs={0} />
        <Select name={'countryCode'} label={t('common.country')} options={allCountries} isSearchable required />
      </Stack>
      <Checkbox
        name={'reReleaseInstallationStatement'}
        label={t('installation-details.change-location.release-installation-statement')}
        sx={{ marginTop: 4, marginBottom: 4 }}
      />
      <Typography variant="subtitle2" sx={{ marginBottom: 4 }}>
        {t('installation-details.change-location.reason-hint')}
      </Typography>
      <TextField label={t('installation-details.change-location.reason')} name="reason" required multiline />
    </form>
  )
}

export default ChangeLocationForm
